export const isValidJsonString = (value: string): boolean => {
    if (!value.trim()) {
        return false;
    }

    if (value.trim() === '""') {
        return false;
    }

    try {
        JSON.parse(value);
        return true;
    } catch {
        return false;
    }
};
